import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import ErrorBox from './ErrorBox/ErrorBox';

const ErrorBoundary: React.FC = ({ children }) => {
    return (
        <ReactErrorBoundary fallbackRender={({ error }) => <ErrorBox message={error.message} />}>
            {children}
        </ReactErrorBoundary>
    );
};

export default ErrorBoundary;
